import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import AdminAddDashboardsList from '@src/main/ui/components/AdminAddDashboards/common/AdminAddDashboardsList/AdminAddDashboardsList';

import { useAreaContext } from '@src/main/ui/providers/area/AreaContextProvider';
import { type FC } from 'react';
import { useParams } from 'react-router-dom';

const AdminAddDashboardsArea: FC = () => {
  const { areas } = useAreaContext();
  const { areaId } = useParams();
  const area = areas?.find((areaItem) => areaItem.id === areaId);
  const subareas = area?.subareas;

  if (!subareas) return <></>;

  return (
    <>
      <Typography variant="h3" sx={{ paddingRight: '40px' }}>
        {area.name}
      </Typography>
      <Box>
        <AdminAddDashboardsList
          items={subareas.sort((a, b) => a.name.localeCompare(b.name))}
          navigateURL={(id: string) => `/admin/add-dashboards/areas/${areaId}/${id}`}
          actions={{
            add: true,
            edit: true,
            delete: true,
          }}
        />
      </Box>
    </>
  );
};

export default AdminAddDashboardsArea;
